import type { SVGProps } from 'react';

const SvgAlarmOnMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <circle cx={21.5781} cy={2} r={2} fill='#FF5A5A' />
    <path
      d='M11.9973 3C15.0043 3 17.4425 5.43817 17.4425 8.44524V9.31396C17.4425 10.5908 18.3566 11.7118 18.8148 12.9035C18.9344 13.2146 18.9999 13.5524 19 13.9058C19 15.268 18.0211 16.4337 16.6709 16.6136C15.2423 16.8038 13.4204 17 11.9995 17C10.5785 17 8.75753 16.8037 7.32914 16.6136C5.9788 16.4338 5 15.2681 5 13.9058C5.00006 13.5527 5.06551 13.2152 5.18488 12.9044C5.64191 11.7144 6.55312 10.5949 6.55312 9.32013V8.44524C6.55312 5.43821 8.99025 3.00006 11.9973 3Z'
      stroke='currentColor'
      strokeWidth={1.5}
    />
    <path d='M12 21C9.33333 21 8.22222 18.3333 8 17H16C15.7778 18.3333 14.6667 21 12 21Z' fill='currentColor' />
  </svg>
);
export default SvgAlarmOnMd;
